<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader" *ngIf="labDetailsId > 0">
      <mat-icon>edit</mat-icon> Edit {{lab.labName}}
    </h2>
    <h2 class="noMarginHeader" *ngIf="labDetailsId == 0">
      <mat-icon>add</mat-icon> Add Organization
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button type="submit" (click)="onSubmit()" mat-raised-button color="primary"
      title="{{buttonText}}" [disabled]="authService.isReadOnly()">{{buttonText}}</button>
    &nbsp;&nbsp;
    <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic"
      title="Close">Close</button>
  </div>
</div>
<mat-dialog-content *ngIf="!loading">
  <form #form="ngForm" [formGroup]="labForm" class="form-field-full">
    <br />
    <span *ngIf="postErrorMessages != ''" class="error">{{postErrorMessages}}<br /><br /></span>
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <mat-card fxFlex="100">
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labName" placeholder="Organization Name" matInput required />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="displayName" placeholder="Display Name" matInput required
                  matTooltipClass="tooltip"
                  matTooltip="The Display name can be used as a short name for the Lab that is displayed in drop downs. This helps save space (Ex: COLUMBIA INSPECTION INC display name is - Columbia Inspection)" />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="doingBusinessAs" placeholder="Doing Business As" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="orelap" placeholder="Orelap" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <mat-label>Organization active?</mat-label>
                <mat-select formControlName="active">
                  <mat-option value="true">Yes</mat-option>
                  <mat-option value="false">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <mat-label>County</mat-label>
                <mat-select formControlName="labCounty" value="{{labForm.value.labCounty}}">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let item of oregonWellDataService.counties" value="{{item.value}}">{{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
        <mat-card fxFlex="100">
          <strong>Physical Address</strong>
          <br /><br />
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labAddress1" placeholder="Physical Address 1" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labAddress2" placeholder="Physical Address 2" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="labCity" placeholder="City" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="labState" placeholder="State" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="labZip" placeholder="Zip" matInput />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
      <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
        <mat-card fxFlex="100">
          <strong>Mailing Address</strong>
          <br /><br />
          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between center">
            <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="mailingAddress1" placeholder="Mailing Address 1" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="mailingAddress2" placeholder="Mailing Address 2" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between center">
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="mailingCity" placeholder="City" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="mailingState" placeholder="State" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100" class="matero-col">
              <mat-form-field>
                <input type="text" formControlName="mailingZip" placeholder="Zip" matInput />
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div fxLayout="row wrap" class="matero-row">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
        <mat-card fxFlex="100">
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labContact" placeholder="Contact" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labPhone" placeholder="Phone" matInput />
              </mat-form-field>
            </div>
            <div fxFlex="33.33" fxFlex.lt-sm="100">
              <mat-form-field>
                <input type="text" formControlName="labEmail" placeholder="Email" matInput />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <mat-form-field>
                <mat-label>Comments</mat-label>
                <textarea rows="3" cols="100" formControlName="comments" id="comments" name="comments" matInput></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</mat-dialog-content>